export default __webpack_public_path__ + "ba1272744f952780f64418445b9c8ae3.pdf";